import { PageHeader } from '@/shared/components/PageHeader';
import { Layers } from 'lucide-react';
import JobCategoriesStep from '../components/JobCategoriesStep';

export default function JobCategoriesPage() {
  return (
    <>
      <PageHeader
        title="Job Categories"
        subtitle="View and manage job category types"
        icon={<Layers className="size-7 text-primary" />}
      />

      <JobCategoriesStep />
    </>
  );
}
